// extracted by mini-css-extract-plugin
module.exports = {"base":"Pill__base__91M7D","active":"Pill__active__3xW-s","isRemovable":"Pill__isRemovable__1Pr2u","pillRemove":"Pill__pillRemove__2JFcW"};